



















































import { Component, Vue } from 'vue-property-decorator';
import { Container, Draggable } from 'vue-smooth-dnd';
import Footer from '@/components/Footer.vue';
import PartService from '@/services/part';
import Loader from '@/components/Loader.vue';
import LoadableContainer from '@/components/LoadableContainer.vue';
import Part from '@/entities/Part';
import Icon from '@/components/Icon.vue';

@Component({
  components: {
    Icon,
    LoadableContainer,
    Loader,
    Footer,
    Container,
    Draggable,
  },
})
export default class Parts extends Vue {
  partService = new PartService();

  partToRemove: Part = null;

  orderChanged = false;

  get parts() {
    return this.partService.list;
  }

  goToPart(part: Part) {
    this.$router.push({
      name: 'Part',
      params: {
        id: part.id,
      },
    });
  }

  remove() {
    this.partService.delete(this.partToRemove);
  }

  onDrop(dropResult: any) {
    const { removedIndex, addedIndex } = dropResult;
    if (removedIndex !== addedIndex) {
      this.orderChanged = true;
      this.partService.move(removedIndex, addedIndex);
    }
  }

  saveOrder() {
    this.partService.saveOrder(this.parts)
      .then(() => {
        this.orderChanged = false;
      });
  }
}
